import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "q-row products__promoted-product-container"
}
const _hoisted_3 = { class: "q-col-sm-12 products__promoted-product-container-inner" }
const _hoisted_4 = { class: "products__promoted-product q-p-1 q-position-relative q-d-flex q-flex-wrap" }
const _hoisted_5 = { class: "products__promoted-product-image-container q-col-4 q-col-md-12 q-p-0" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "products__promoted-product-info q-col-8 q-col-md-12 q-px-2 q-text-black q-text-start" }
const _hoisted_8 = { class: "products__promoted-product-title q-m-0 q-fw-bold" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

import AutocompletePriceBox from '@/components/AutocompletePopup/AutocompletePriceBox.vue';
import { ref, inject, onUpdated, watch, computed } from 'vue';
import { generateStaticImage, addDisplayMacros, formatPrice, parsePrice, getDiscount, getRealPrice } from '@/core/utils';
import { createTemplate } from '@/core/Template';
import { SmartSearchConfigInterface } from '@/core/types';

// Pobieramy konfigurację – zakładamy, że endpoint zwraca obiekt topProduct zawierający m.in. productImageSize oraz szablon

export default /*@__PURE__*/_defineComponent({
  __name: 'PromotedProduct',
  props: ['promotedProduct'],
  setup(__props) {

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!);
const { width, height } = SmartSearchConfig.value.onfocus.topProduct.productImageSize;
const { useQuarticImages } = SmartSearchConfig.value.serp.productImageSize;

const customTemplate = SmartSearchConfig?.value?.serp?.customComponents?.topProduct || null;

const props = __props;

// Inicjalizacja podstawowych danych
const promotedProductVariant = ref(props.promotedProduct.variants[0]);
const promotedProductTitle = ref(props.promotedProduct.title);
const actualLink = ref(props.promotedProduct.link);
const clickLink = ref(props.promotedProduct.link_click);
const productId = ref(props.promotedProduct.id);

// Obliczenie ścieżki do obrazu
const staticImage = computed(() => {
  const imageLink = promotedProductVariant.value.image_link;
  if (!useQuarticImages) {
    return imageLink;
  }
  return imageLink
      ? generateStaticImage(imageLink, width, height)
      : generateStaticImage('https://static.quartic.com.pl/img/no-image/no-image.png', width, height);
});

// Obsługa kliknięcia – ewentualna modyfikacja linku
const handleClick = () => {
  actualLink.value = clickLink.value;
};

onUpdated(() => {
  staticImage.value = useQuarticImages
      ? generateStaticImage(props.promotedProduct.variants[0].image_link, width, height)
      : props.promotedProduct.variants[0].image_link;
});

watch(() => props.promotedProduct, (newValue) => {
  actualLink.value = newValue.link;
  clickLink.value = newValue.link_click;
  promotedProductTitle.value = newValue.title;
  promotedProductVariant.value = newValue.variants[0];
  staticImage.value = useQuarticImages
      ? generateStaticImage(newValue.variants[0].image_link, width, height)
      : newValue.variants[0].image_link;
}, { deep: true });

// Obliczenia dodatkowych makr
const secondPrice = promotedProductVariant.value.old_price || promotedProductVariant.value.sale_price;
const { price, oldPrice } = getRealPrice(parsePrice(promotedProductVariant.value.price), parsePrice(secondPrice));
const omnibusPrice = parsePrice(promotedProductVariant.value.omnibus_price);
const formattedPrice = formatPrice(price, SmartSearchConfig.value.appConfiguration.currency, SmartSearchConfig.value.appConfiguration.removeDecimals);
const formattedPriceOld = formatPrice(oldPrice, SmartSearchConfig.value.appConfiguration.currency, SmartSearchConfig.value.appConfiguration.removeDecimals);
const formattedOmnibusPrice = formatPrice(omnibusPrice, SmartSearchConfig.value.appConfiguration.currency, SmartSearchConfig.value.appConfiguration.removeDecimals);
const discount = getDiscount(price, oldPrice);

// Funkcja przygotowująca czysty link (z zamianą protokołu)
const prepareClearLink = (link: string, clickLink: string) => {
  return ` href="${link}" data-href="${clickLink.replace(/^http:/, 'https:')}" onmousedown="return this.href = this.getAttribute('data-href');" ontouchstart="return this.href = this.getAttribute('data-href');" `;
};

// Jeśli jest dostępny niestandardowy szablon, rozszerzamy dane wariantu o makra i generujemy HTML
let generatedHtml = ref('');
if (customTemplate) {
  promotedProductVariant.value.discount = discount;
  promotedProductVariant.value.image_link_cdn = staticImage.value;
  promotedProductVariant.value.price_formatted = formattedPrice;
  promotedProductVariant.value.price_number = price;
  promotedProductVariant.value.old_price_formatted = formattedPriceOld;
  promotedProductVariant.value.old_price_number = oldPrice;
  promotedProductVariant.value.omnibus_price_formatted = formattedOmnibusPrice;
  promotedProductVariant.value.omnibus_price_number = omnibusPrice;
  promotedProductVariant.value.id = productId.value;
  promotedProductVariant.value.link_click = clickLink.value;
  promotedProductVariant.value.clear_link = prepareClearLink(actualLink.value, clickLink.value);

  // Dodatkowa modyfikacja danych
  addDisplayMacros(promotedProductVariant.value);

  // Generujemy HTML przy użyciu createTemplate – dla topProduct przyjmujemy, że nie mamy pętli, więc przekazujemy wariant jako główny produkt oraz jako jedyny element tablicy
  generatedHtml.value = createTemplate(customTemplate, promotedProductVariant.value, [promotedProductVariant.value]);
}

return (_ctx: any,_cache: any) => {
  return (_unref(customTemplate))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        innerHTML: _unref(generatedHtml)
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "products__promoted-product-image q-p-1",
                src: staticImage.value,
                alt: promotedProductTitle.value
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(promotedProductTitle.value), 1),
              _createVNode(AutocompletePriceBox, { product: promotedProductVariant.value }, null, 8, ["product"]),
              _createElementVNode("a", {
                href: actualLink.value,
                onClick: handleClick,
                class: "q-stretched-link"
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("a", {
              href: actualLink.value,
              onClick: handleClick,
              class: "q-stretched-link"
            }, null, 8, _hoisted_10)
          ])
        ])
      ]))
}
}

})